import { trackProps as trackable } from '@dpdgroupuk/react-event-tracker';
export { trackable };

export const trackableModal = modal => ({
  interfaceId: modal.INTERFACE_ID,
  loadId: modal.LOAD,
  confirm: modal.CONFIRM,
  ...modal,
});

export const HEADER = {
  BACK_TO_SITE: 'ot9AFXaD.AAAAV1k',
  CHANGE_COLLECTION: 'VJ8_5XaD.AAAAV0y',
  DOWN_LOAD_APP: '8J._5XaD.AAAAV1X',
  DROP_DOWN_MENU: 'bsvf5XaD.AAAAV0V',
  LEARN_MORE_ABOUT_DRIVER: 'ifXAFXaD.AAAAV15',
  PARCEL_INFO_BUTTON: 'ExKrrHaFYFxo24xP',
  REAL_TIME_COLLECTION_UPDATES: 'bny_5XaD.AAAAV0.',
  SHOW_DEPOT_MAP: 'KGqbrHaFYFxo241S',
  SHOW_SHOP_MAP: 'IGWbrHaFYFxo241x',
  TOGGLE_DARK: 'FzLAFXaD.AAAAV1z',
  TRACK_ANOTHER_COLLECTION: '9km_5XaD.AAAAV1H',
  COLLECTION_INFO: 'lj2_5XaD.AAAAV1N',
  VIEW_TRACKING: '',
};

export const SPEED_DEAL = {
  BACK_TO_SITE: '_NMcFXaD.AAAAaOc',
  CHANGE_COLLECTION: 'KqbiFXaD.AAAAaOx',
  LEARN_MORE_ABOUT_DRIVER: '4kYSFXaD.AAAAaPQ',
  COLLECTION_INFO: '678cFXaD.AAAAaOl',
  REAL_TIME_COLLECTION_UPDATES: 'DIScFXaD.AAAAaOs',
  TOGGLE_HIDE_SHOW: 'BykcFXaD.AAAAaOT',
  VIEW_TRACKING: 'skITWPaD.AAAAZSi',
  DO_SOMETHING_DIFFERENT: '',
  TRACK_ANOTHER_COLLECTION: '', // TODO add when it will be present https://it.dpdgroup.co.uk/it/diagram/diag_FhRsFXaD.AAAAZ5V.html?id=1581504807729
};

export const REFERENCE_ENTRY = {
  INTERFACE_ID: 'Xfw0RXaD.AAAAZqm',
  LOAD: 'QjiqRXaD.AAAASvB',
  ENTER_POSTCODE: '9yJqRXaD.AAAASvv',
  ENTER_REFERENCE: '4xeqRXaD.AAAASvl',
  SEARCH: 'fWaqRXaD.AAAASvT',
};

export const REF_ENTRY_MODAL = trackableModal({
  INTERFACE_ID: 'pN2sRXaD.AAAAZtU',
  LOAD: 'IBjcRXaD.AAAAR3E',
  CONFIRM: '8hoSRXaD.AAAASO3',
});

export const LITE_VIEW_MODAL = trackableModal({
  INTERFACE_ID: 'I6QNxXaD.AAAAUDQ',
  LOAD: 'Ot0ytXaD.AAAAWsG',
  CONFIRM: 'yPMytXaD.AAAAWsO',
});

export const LITE_VIEW_TRACKING = {
  INTERFACE_ID: '8iB1xXaD.AAAAT3e',
  LOAD: 'dA7ItXaD.AAAAUNK',
  SUBMIT: '3eHItXaD.AAAAUNP',
};

export const GENERAL_VIEW = {
  INTERFACE_ID: 'Y2UtxXaD.AAAAUa_',
  LOAD: 'nponqPaD.AAAAb3r',
};

export const OUT_FOR_DELIVERY = {
  INTERFACE_ID: 'i8VwWPaD.AAAAWS3',
  LOAD: '.ZeXWPaD.AAAAbK4',
};

export const COLLECTED_VIEW = {
  INTERFACE_ID: 'Gw8S9faD.AAAAXOO',
  LOAD: 'sXEK9faD.AAAAXau',
};

export const COLLECTION_OPTIONS = {
  INTERFACE_ID: '1XqTS_aD.AAAAaph',
  LOAD: 'm1ozS_aD.AAAAar_',
  GO_TO_TRACKING_MAP: 'TcFMG_aD.AAAAZN1',
  CAN: 'H6b8G_aD.AAAAalm',
  CFN: '1j18G_aD.AAAAak9',
  CHD: 'Zb68G_aD.AAAAaYc',
  SFP: 'jLB8G_aD.AAAAaY3',
};

export const CHD = {
  INTERFACE_ID: 'd8vSG_aD.AAAAcL3',
  LOAD: 'HFtUAA6D.AAAASeD',
  SUBMIT: 'fRiWAA6D.AAAAXrg',
};

export const CFN = {
  INTERFACE_ID: 'a3nSG_aD.AAAAcLy',
  LOAD: 'gFypgA6D.AAAAQzH',
  SUBMIT: 'BZNNgA6D.AAAAdU9',
};

export const SFP = {
  INTERFACE_ID: 'NkAyG_aD.AAAAcL8',
  LOAD: 'jCwGgA6D.AAAAcam',
  SUBMIT: 'qphGgA6D.AAAAcoT',
};

export const CANCEL_MODAL = trackableModal({
  INTERFACE_ID: 'KLjSG_aD.AAAAcLm',
  LOAD: 'I_tfKA6D.AAAAQp5',
  CONFIRM: 'i16_KA6D.AAAARh7',
  YES: 'q3VhgA6D.AAAAeI3',
  NO: 'BuphgA6D.AAAAeIl',
});

export const WIZARD_CHD = {
  ON_DAY_SELECT: 'Sjk8AA6D.AAAATMC',
  ON_SUBMIT: 'EnD8AA6D.AAAATaE',
};

export const WIZARD_SFP = {
  ON_SELECT: '59eEgA6D.AAAAZ0P',
  ON_SUBMIT: 'bo0eAA6D.AAAAYjn',
};

export const WIZARD_CFN = {
  ON_SELECT: 'TSvVgA6D.AAAAcRr',
  ON_SUBMIT: 'VMN1gA6D.AAAAcsO',
};

export const WIZARD_PHOTO = {
  ON_BROWSE: 'PAlagA6D.AAAAb9d',
  ON_SKIP: 'OypKgA6D.AAAAbVq',
  ON_DND: 'VhyqgA6D.AAAAbjG',
};

export const WIZARD_CONTACTS = {
  ON_CONTACT: 'S3BqAA6D.AAAAVv.',
  ON_EMAIL: 'cA5aAA6D.AAAAV.N',
  ON_PHONE: 'NjQaAA6D.AAAAV9Q',
  ON_SUBMIT: 'e6p6AA6D.AAAAWNZ',
};

export const WIZARD_COMMON = {
  ON_DATE_CHANGE: 'nic4gA6D.AAAAZN6',
  BACK_TO_TRACKING: '..7WgA6D.AAAAdG9',
};

export const COLLECTION_EVENTS = {
  INTERFACE_ID: 'OoJNWPaD.AAAAY6A',
  LOAD: 'RsUdWPaD.AAAAY68',
  VIEW_INFO: 'S1tzWPaD.AAAAZfl',
  VIEW_TRACKING: 'skITWPaD.AAAAZSi',
};

export const DRIVER_PROFILE = {
  INTERFACE_ID: 'XaQYdfaD.AAAAVdI',
  LOAD: 'TTCYdfaD.AAAAVe2',
  GO_TO_TRACKING_MAP: 'OkbY9faD.AAAAWn9',
};

export const CONFIRMATION_SCREEN = {
  INTERFACE_ID: 'rordgA6D.AAAAQGw',
  LOAD: 'JE29gA6D.AAAAQJV',
  TRACK_ANOTHER_COLLECTION: 'AqpDgA6D.AAAAQdl',
};

export const ERROR_SCREEN = {
  INTERFACE_ID: 'TODO', // TODO add valid interface id
};

export const FOOTER = {
  GDPR: 'rjMR5XaD.AAAAUNz',
  PHISHING: 'AawR5XaD.AAAAUNY',
  PRIVACY: 'i.lh5XaD.AAAAUMV',
  TERMS: 'VoHh5XaD.AAAAUM8',
};
